import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import { dosyaIndir, blobHatasiOku } from '../excel';
import './KurumFaturalari.css';

// "Kurum Faturaları" — anlaşmalı sigorta kurumlarına kesilen e-faturalar
// (kullanıcı talebi: 2026-09-08). VB6'daki "Kurum e-Fatura İşlemleri" ekranının karşılığı;
// filtre yerleşimi bilerek ona benzetildi.
//
// HASTA PAYI FATURASI — beş durum (kullanıcı kuralı: 2026-09-08). Hasta payı satırı =
// REFERANS.NE=1 ve tutar >= 10 TL (NE=2 kurum payıdır; 10 TL altı kuruşluk kayıtlar
// gerçek hasta payı değil, kullanıcı kararıyla sayılmıyor).
//   VAR                provizyon eşleşiyor, fatura KESİLMİŞ
//   ÖN FATURA          provizyon eşleşiyor, fatura kesilmemiş
//   ŞÜPHELİ (kesilmiş) provizyon eşleşmiyor ama hastanın kesilmiş hasta payı faturası var
//   ŞÜPHELİ (kesilmemiş) aynısı, fatura kesilmemiş
//   YOK                hiç hasta payı satırı yok (hasta payı sıfır olanlar da burada)

const bugun = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const isoTarih = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const ayBasi = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

const trTarih = (iso) => (iso ? `${String(iso).slice(8, 10)}.${String(iso).slice(5, 7)}.${String(iso).slice(0, 4)}` : '');
const trPara = (n) => (n ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Üç durumlu süzgeç: '' = tümü, '1' = evet, '0' = hayır.
//
// VB6 ekranındaki gibi RADYO DÜĞMESİ (kullanıcı talebi: 2026-09-08). Orada olumlu seçenek
// yeşil, olumsuz kırmızı yazılıyor; aynı renk dili korundu, "Tümü" nötr.
function UcDurum({ etiket, deger, ayarla, evet, hayir }) {
  // Radyo grubunu tarayıcının ayırt edebilmesi için benzersiz bir ad gerekiyor.
  const grup = `kf-${etiket.replace(/s+/g, '-').toLowerCase()}`;
  const secenekler = [['1', evet, 'olumlu'], ['0', hayir, 'olumsuz'], ['', 'Tümü', 'notr']];

  return (
    <fieldset className="kf-ucdurum">
      <legend className="kf-ucdurum-ad">{etiket}</legend>
      <div className="kf-radyolar">
        {secenekler.map(([v, ad, sinif]) => (
          <label key={v} className={`kf-radyo kf-${sinif}${deger === v ? ' secili' : ''}`}>
            <input type="radio" name={grup} checked={deger === v} onChange={() => ayarla(v)} />
            {ad}
          </label>
        ))}
      </div>
    </fieldset>
  );
}

// Rozet metinleri ve üzerine gelince çıkan açıklamalar tek yerde.
const PAYI_ETIKET = {
  var: 'HASTA PAYI FATURASI VAR',
  onfatura: 'HASTA PAYI FATURASI VAR · KESİLMEMİŞ',
  supheli_kesilmis: '⚠ PROVİZYON EŞLEŞMİYOR · HASTA PAYI FATURASI VAR (kesilmiş)',
  supheli_kesilmemis: '⚠ PROVİZYON EŞLEŞMİYOR · HASTA PAYI FATURASI VAR (kesilmemiş)',
  yok: 'HASTA PAYI FATURASI YOK',
};

const PAYI_ACIKLAMA = {
  onfatura: 'Provizyon eşleşiyor, hasta payı faturası var ama henüz kesilmemiş (ön fatura).',
  supheli_kesilmis:
    'Provizyon numarası eşleşmiyor; ancak bu hastanın kesilmiş bir hasta payı faturası var. '
    + 'Tek başına delil değildir, kontrol edilmelidir.',
  supheli_kesilmemis:
    'Provizyon numarası eşleşmiyor; hastanın hasta payı kaydı var ama faturası kesilmemiş. '
    + 'Tek başına delil değildir, kontrol edilmelidir.',
  yok: 'Bu hastaya ait, tutarı 10 TL ve üzeri bir hasta payı kaydı bulunamadı.',
};

// Hızlı dönem düğmeleri — en sık kullanılan aralıklar tek tıkla.
const DONEMLER = [
  { ad: 'Bu ay', uygula: () => ({ baslangic: ayBasi(), bitis: bugun() }) },
  {
    ad: 'Geçen ay',
    uygula: () => {
      const d = new Date();
      const bas = new Date(d.getFullYear(), d.getMonth() - 1, 1);
      const bit = new Date(d.getFullYear(), d.getMonth(), 0);
      return { baslangic: isoTarih(bas), bitis: isoTarih(bit) };
    },
  },
  { ad: 'Bu yıl', uygula: () => ({ baslangic: `${new Date().getFullYear()}-01-01`, bitis: bugun() }) },
];

const HASTA_PAYI_SECENEKLERI = [
  ['', 'Tümü', 'notr'],
  ['var', 'Var', 'olumlu'],
  ['onfatura', 'Kesilmemiş', 'notr'],
  ['supheli_kesilmis', 'Şüpheli · kesilmiş', 'uyari'],
  ['supheli_kesilmemis', 'Şüpheli · kesilmemiş', 'uyari'],
  ['yok', 'Yok', 'olumsuz'],
];

// "Diğer süzgeçler" altındaki alanlar — kaçının varsayılandan farklı olduğunu saymak için.
const GELISMIS_ALANLAR = [
  'gecerli', 'manuel', 'faturaKesildi', 'belgeAlindi', 'subeyeYollandi',
  'sifirTutar', 'faturaNo', 'provNo', 'protNo',
];

const bosFiltre = {
  baslangic: ayBasi(),
  bitis: bugun(),
  kurum: '',
  hastaAdi: '',
  faturaNo: '',
  onFaturaNo: '',
  provNo: '',
  protNo: '',
  gecerli: '1',
  manuel: '',
  sifirTutar: '',
  faturaKesildi: '',
  belgeAlindi: '',
  subeyeYollandi: '',
  hastaPayi: '',
};

export default function KurumFaturalari() {
  const [f, setF] = useState(bosFiltre);
  const [kurumlar, setKurumlar] = useState([]);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [aktariliyor, setAktariliyor] = useState(false);
  const [hata, setHata] = useState('');
  // Gelişmiş süzgeçler varsayılanda kapalı; içlerinden biri değiştirilmişse başlıkta rozet çıkar.
  const [gelismis, setGelismis] = useState(false);

  useEffect(() => {
    api.get('/KurumFatura/kurumlar')
      .then(({ data }) => setKurumlar(data))
      .catch(() => { /* liste dolmazsa kurum adı elle de yazılabilir */ });
  }, []);

  // Boş ve "Tümü" seçili alanlar sunucuya HİÇ gönderilmiyor; aksi halde her biri
  // gereksiz bir koşul üretirdi.
  const parametreler = useCallback(() => {
    const p = {};
    const ekle = (ad, deger) => { if (deger !== '' && deger != null) p[ad] = deger; };
    ekle('baslangic', f.baslangic);
    ekle('bitis', f.bitis);
    ekle('kurum', f.kurum.trim());
    ekle('hastaAdi', f.hastaAdi.trim());
    ekle('faturaNo', f.faturaNo.trim());
    ekle('onFaturaNo', f.onFaturaNo.trim());
    ekle('provNo', f.provNo.trim());
    ekle('protNo', f.protNo.trim());
    ['gecerli', 'manuel', 'sifirTutar', 'faturaKesildi', 'belgeAlindi', 'subeyeYollandi']
      .forEach(ad => { if (f[ad] !== '') p[ad] = f[ad] === '1'; });
    // Hasta payı üç durumlu: değeri olduğu gibi gider ("var" | "supheli" | "yok").
    ekle('hastaPayi', f.hastaPayi);
    return p;
  }, [f]);

  const listele = async (e) => {
    if (e) e.preventDefault();
    setYukleniyor(true); setHata('');
    try {
      const { data } = await api.get('/KurumFatura', { params: parametreler() });
      setSonuc(data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Fatura listesi alınamadı.');
      setSonuc(null);
    } finally {
      setYukleniyor(false);
    }
  };

  const disaAktar = async () => {
    setAktariliyor(true); setHata('');
    try {
      const yanit = await api.get('/KurumFatura/excel', { params: parametreler(), responseType: 'blob' });
      dosyaIndir(yanit);
    } catch (err) {
      setHata(await blobHatasiOku(err) || 'Excel dosyası oluşturulamadı.');
    } finally {
      setAktariliyor(false);
    }
  };

  const gelismisAktif = GELISMIS_ALANLAR.filter(ad => f[ad] !== bosFiltre[ad]).length;

  const kayitlar = sonuc?.kayitlar ?? [];
  // Bu şubenin REFERANS_EFATURA tablosu eski şemada mı? (bkz. KurumFaturaServisi)
  const desteksiz = sonuc != null && sonuc.destekleniyor === false;

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <h2 style={{ margin: 0, color: 'var(--med-dark)' }}>🧾 Kurum Faturaları</h2>
      </div>

      {hata && <div className="hata-kutu">{hata}</div>}

      {/* FİLTRELER — üç kademe (kullanıcı: 2026-09-14, "karma karışık").
          1) Hep görünen temel alanlar: dönem, kurum, hasta
          2) Ekranın asıl sorusu: hasta payı faturası
          3) Geri kalan her şey "Diğer süzgeçler" altında kapalı duruyor; kaçının açık
             olduğu başlıkta rozetle yazıyor ki gizlenen ayar unutulmasın. */}
      <form className="card kf-filtre" onSubmit={listele}>
        <div className="kf-temel">
          <div className="kf-alan kf-donem">
            <label className="kf-etiket">Dönem</label>
            <div className="kf-donem-kutular">
              <input type="date" value={f.baslangic} onChange={e => setF({ ...f, baslangic: e.target.value })} />
              <span className="kf-tire">–</span>
              <input type="date" value={f.bitis} onChange={e => setF({ ...f, bitis: e.target.value })} />
            </div>
            <div className="kf-hizli">
              {DONEMLER.map(d => (
                <button key={d.ad} type="button" className="kf-hizli-btn"
                        onClick={() => setF({ ...f, ...d.uygula() })}>
                  {d.ad}
                </button>
              ))}
            </div>
          </div>

          <div className="kf-alan">
            <label className="kf-etiket">Kurum Adı</label>
            <input list="kf-kurumlar" value={f.kurum} onChange={e => setF({ ...f, kurum: e.target.value })}
                   placeholder="Tümü" />
            <datalist id="kf-kurumlar">
              {kurumlar.map(k => <option key={k} value={k} />)}
            </datalist>
          </div>

          <div className="kf-alan">
            <label className="kf-etiket">Hasta Adı</label>
            <input value={f.hastaAdi} onChange={e => setF({ ...f, hastaAdi: e.target.value })} placeholder="Tümü" />
          </div>

          <div className="kf-dugmeler">
            <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
              {yukleniyor ? '...' : '🔎 Listele'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setF(bosFiltre)}>Temizle</button>
          </div>
        </div>

        {/* Ekranın asıl sorusu; o yüzden ayrı ve vurgulu bir şeritte. */}
        <div className="kf-odak">
          <span className="kf-odak-ad">Hasta Payı Faturası</span>
          <div className="kf-radyolar">
            {HASTA_PAYI_SECENEKLERI.map(([v, ad, sinif]) => (
              <label key={v} className={`kf-radyo kf-${sinif}${f.hastaPayi === v ? ' secili' : ''}`}>
                <input type="radio" name="kf-hasta-payi" checked={f.hastaPayi === v}
                       onChange={() => setF({ ...f, hastaPayi: v })} />
                {ad}
              </label>
            ))}
          </div>
        </div>

        <button type="button" className="kf-gelismis-basi" onClick={() => setGelismis(!gelismis)}
                aria-expanded={gelismis}>
          <span className="kf-ok">{gelismis ? '▾' : '▸'}</span>
          Diğer süzgeçler
          {gelismisAktif > 0 && <span className="kf-rozet">{gelismisAktif} açık</span>}
        </button>

        {gelismis && (
          <div className="kf-gelismis">
            <UcDurum etiket="Kayıt" deger={f.gecerli} ayarla={v => setF({ ...f, gecerli: v })}
                     evet="Geçerli" hayir="Geçersiz" />
            <UcDurum etiket="Kaynak" deger={f.manuel} ayarla={v => setF({ ...f, manuel: v })}
                     evet="Manuel" hayir="Dr.Plazma" />
            <UcDurum etiket="Faturası" deger={f.faturaKesildi} ayarla={v => setF({ ...f, faturaKesildi: v })}
                     evet="Kesildi" hayir="Kesilmedi" />
            <UcDurum etiket="Belge" deger={f.belgeAlindi} ayarla={v => setF({ ...f, belgeAlindi: v })}
                     evet="Alındı" hayir="Alınmadı" />
            <UcDurum etiket="Diğer Şubeye" deger={f.subeyeYollandi} ayarla={v => setF({ ...f, subeyeYollandi: v })}
                     evet="Yollandı" hayir="Yollanmadı" />
            <UcDurum etiket="Tutar" deger={f.sifirTutar} ayarla={v => setF({ ...f, sifirTutar: v })}
                     evet="Sıfır olanlar" hayir="Sıfırdan farklı" />

            <div className="kf-alan">
              <label className="kf-etiket">Fatura No</label>
              <input value={f.faturaNo} onChange={e => setF({ ...f, faturaNo: e.target.value })} placeholder="Tümü" />
            </div>
            <div className="kf-alan">
              <label className="kf-etiket">Prov. No</label>
              <input value={f.provNo} onChange={e => setF({ ...f, provNo: e.target.value })} placeholder="Tümü" />
            </div>
            <div className="kf-alan">
              <label className="kf-etiket">Protokol No</label>
              <input value={f.protNo} onChange={e => setF({ ...f, protNo: e.target.value })} placeholder="Tümü" />
            </div>
          </div>
        )}
      </form>

      {desteksiz && (
        <div className="hata-kutu" style={{ background: '#FAEEDA', color: '#633806' }}>
          Bu şubede kurum e-fatura kaydı tutulmuyor: REFERANS_EFATURA tablosu eski sürümde ve
          provizyon numarası (PROVNO) alanı yok. Ekran yalnızca bu alanların bulunduğu şubelerde
          çalışır.
        </div>
      )}

      {sonuc && !desteksiz && (
        <div className="kf-ozet">
          <span><strong>{sonuc.toplam.toLocaleString('tr-TR')}</strong> fatura</span>
          <span>Genel Toplam: <strong>{trPara(sonuc.genelToplam)} TL</strong></span>
          <span className="kf-ozet-payi">
            Hasta payı — VAR: <strong>{kayitlar.filter(k => k.hastaPayi === 'var').length}</strong> ·
            ÖN FATURA: <strong>{kayitlar.filter(k => k.hastaPayi === 'onfatura').length}</strong> ·
            ŞÜPHELİ: <strong>{kayitlar.filter(k => k.hastaPayi.startsWith('supheli')).length}</strong> ·
            YOK: <strong>{kayitlar.filter(k => k.hastaPayi === 'yok').length}</strong>
          </span>
          <button className="btn cc-btn-excel" onClick={disaAktar} disabled={aktariliyor}>
            <svg className="cc-excel-ikon" viewBox="0 0 16 16" aria-hidden="true">
              <path d="M9.5 1H3.5A1.5 1.5 0 0 0 2 2.5v11A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V5.5L9.5 1z" />
              <path className="cc-excel-kivrim" d="M9.5 1v3.2c0 .7.6 1.3 1.3 1.3H14" />
              <path className="cc-excel-x" d="M5.6 7.6l4.8 5.2M10.4 7.6l-4.8 5.2" />
            </svg>
            {aktariliyor ? 'Hazırlanıyor...' : 'Excel'}
          </button>
        </div>
      )}

      {sonuc?.kesildi && (
        <div className="hata-kutu" style={{ background: '#FAEEDA', color: '#633806' }}>
          {sonuc.toplam.toLocaleString('tr-TR')} fatura bulundu, ilk {sonuc.sinir.toLocaleString('tr-TR')} tanesi
          gösteriliyor. Daha dar bir dönem seçin.
        </div>
      )}

      {yukleniyor && <div className="loading">Yükleniyor...</div>}
      {!yukleniyor && sonuc && !desteksiz && kayitlar.length === 0 && (
        <div className="empty">Bu filtrelerle fatura bulunamadı.</div>
      )}
      {!yukleniyor && !sonuc && (
        <div className="empty">Dönem seçip <strong>Listele</strong>'ye basın.</div>
      )}

      {!yukleniyor && kayitlar.length > 0 && (
        <div className="card kf-liste-kutu">
          <table className="kf-tablo">
            <thead>
              <tr>
                <th>Protokol</th><th>Durum</th><th>Tarih</th><th>Saat</th><th>Kurum Adı</th>
                <th>Fatura No</th><th>Prov. No</th><th>Gönderim</th><th>Belge</th>
                <th className="kf-sag">G.Toplam</th><th>Hasta Adı</th><th>Hasta Payı Faturası</th>
              </tr>
            </thead>
            <tbody>
              {kayitlar.map(k => (
                <tr key={k.protNo} className={k.durum === 'Geçersiz' ? 'kf-gecersiz' : ''}>
                  <td>{k.protNo}</td>
                  <td>{k.durum}</td>
                  <td>{trTarih(k.tarih)}</td>
                  <td>{k.saat}</td>
                  <td title={k.kurum}>{k.kurum}</td>
                  <td>{k.faturaNo}</td>
                  <td>{k.provNo}</td>
                  <td title={k.gonderimMesaji}>{k.gonderim}</td>
                  <td title={k.belgeMesaji}>{k.belge}</td>
                  <td className="kf-sag">{trPara(k.genelToplam)}</td>
                  <td title={k.hastaAdi}>{k.hastaAdi}</td>
                  <td>
                    <span className={`kf-payi ${k.hastaPayi}`} title={PAYI_ACIKLAMA[k.hastaPayi] ?? ''}>
                      {PAYI_ETIKET[k.hastaPayi] ?? 'HASTA PAYI FATURASI YOK'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
